/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Price_Include5_SubInputs */

const es_landing_price_include5_sub = /** @type {(inputs: Landing_Price_Include5_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te conseguimos presupuestos de varias aseguradoras, sin compromiso`)
};

const gl_landing_price_include5_sub = /** @type {(inputs: Landing_Price_Include5_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conseguímoste orzamentos de varias aseguradoras, sen compromiso`)
};

const en_landing_price_include5_sub = /** @type {(inputs: Landing_Price_Include5_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We get quotes from several insurers, no obligation`)
};

/**
* | output |
* | --- |
* | "We get quotes from several insurers, no obligation" |
*
* @param {Landing_Price_Include5_SubInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_price_include5_sub = /** @type {((inputs?: Landing_Price_Include5_SubInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Price_Include5_SubInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_price_include5_sub(inputs)
	if (locale === "en") return en_landing_price_include5_sub(inputs)
	return es_landing_price_include5_sub(inputs)
});